
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsor-us",
      function () {
        return require("private-next-pages/sponsor-us.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsor-us"])
      });
    }
  